import React, {
    useMemo,
} from 'react'
import CloudDoneIcon from '@mui/icons-material/CloudDone'
import CloudOffIcon from '@mui/icons-material/CloudOff'
import {
    LoggerType,
} from 'app/enums/label.enums'
import Label from 'app/shared-components/Label'

import getReadingThresholdType, {
    ReadingThresholdType,
} from 'app/utils/getReadingThresholdType'
import Age from './Age'

import useStyles from './TemperatureAge.style'

type Props = {
    value?: number
    title?: string
    rowProps: {
        loggerType?: LoggerType
    }
}

const defaultProps: Partial<Props> = {
    value: undefined,
    title: '',
}

const TemperatureAge = ({
    value,
    title,
    rowProps,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()

    const readingType = useMemo(() => {
        return getReadingThresholdType(value)
    }, [value])

    const icon = useMemo(() => {
        if (value) {
            return (readingType === ReadingThresholdType.LIVE)
                ? (<CloudDoneIcon className={classes.cloudIcon} />)
                : (<CloudOffIcon className={classes.cloudOffIcon} />)
        }

        return null
    }, [
        readingType,
        classes,
        value,
    ])

    return (
        <div>
            {title && (
                <Label
                    title={title}
                />
            )}
            <div className={classes.wrapper}>
                <div
                    className={title ? classes.iconWrapperWithLabel : classes.iconWrapper}
                >
                    {icon}
                </div>
                <Age
                    value={value}
                    className={title ? classes.text : undefined}
                    specialColorCodingProperty={rowProps?.loggerType}
                />
            </div>
        </div>
    )
}

TemperatureAge.defaultProps = defaultProps

export default TemperatureAge
